<template>
    <el-calendar ref="calendar" v-loading="loading" v-model="date">
        <template #header="{date}">
            <span>{{ date }}</span>
            <el-button-group>
                <el-button size="small" @click="selectDate('prev-year')">
                    Previous Year
                </el-button>
                <el-button size="small" @click="selectDate('prev-month')">
                    Previous Month
                </el-button>
                <el-button size="small" @click="selectDate('today')">Today</el-button>
                <el-button size="small" @click="selectDate('next-month')">
                    Next Month
                </el-button>
                <el-button size="small" @click="selectDate('next-year')">
                    Next Year
                </el-button>
            </el-button-group>
        </template>
        <template #date-cell="{data}">
          <div>{{ data.day.split('-').slice(1).join('-') }}</div>
          <div style="height: 80px;" @click="openDialog(data.day)">
            <img style="height: 30px;margin: 2px" :src="`${$root.cdn_url}/${i.thumbnail}`"
                 v-for="i in data_map[data.day].slice(0, 6)" v-if="data_map[data.day]">
          </div>
        </template>
<!--        <template #date-cell="{data: _data}">-->
<!--            <div>{{ _data.day.split('-').slice(1).join('-') }}</div>-->
<!--            <div style="height: 70px;" @click="openDialog(_data.day)">-->
<!--                <template-->
<!--                    v-for="d in data.filter(d=>d.online_date===_data.day).sort((a, b) => a.sort < b.sort ?-1:1).slice(0, 6)">-->
<!--                    <el-image :src="`${$root.cdn_url}/${d.thumbnail}`" style="height: 30px;margin: 2px" lazy></el-image>-->
<!--                </template>-->
<!--            </div>-->
<!--        </template>-->
    </el-calendar>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-select v-model="country" filterable :disabled="loading" placeholder="全球">
          <el-option value="GLOBAL" label="GLOBAL"></el-option>
          <el-option v-for="c in $root.country_list" :value="c.code"
                     :label="c.en_name + ' (' + c.code + ')'"></el-option>
        </el-select>
        <el-select v-model="platform" filterable placeholder="请选择平台" :disabled="loading" style="width: 140px; margin-left: 10px">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
        </el-select>
        <el-button v-if="getProduct().key === 'classic'" :disabled="loading" type="primary" @click="batchOnline()" style="margin-left: 10px" >{{"自动排图"}}</el-button>

        <vue-draggable-next v-model="dayImageList" :animation="300" handle=".handle" @change="sort">
            <transition-group>
                <div style="display: inline-block;position: relative;width: 140px;margin:5px" v-for="image in dayImageList">
                    <el-image style="cursor: pointer;display: block" lazy
                              :src="`${$root.cdn_url}/${image.thumbnail}`" class="handle"></el-image>
                    <el-tag v-if="image.animation" type="success" size="small"
                             style="position: absolute; top: 5px; left: 5px">动图</el-tag>
                    <b style="word-break: break-word">{{ image.id }}</b>
                    <el-icon @click="offline(image)" size="20"
                             style="position: absolute; top: 5px; right: 5px;cursor: pointer;color: var(--el-color-danger)">
                        <DeleteFilled/>
                    </el-icon>
                    <el-icon @click="updateVideo(image)" size="20"
                             style="position: absolute;left: 10px;top: 110px;cursor: pointer">
                        <Lock style="color: var(--el-color-primary)" v-if="image.video"/>
<!--                        <Unlock style="color: var(&#45;&#45;el-color-info)" v-else/>-->
                    </el-icon>
                </div>
            </transition-group>
        </vue-draggable-next>
        <el-divider></el-divider>
        <div>
            <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                       placeholder="分类">
                <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                           :value="c.key"></el-option>
            </el-select>
<!--            <el-select :disabled="loading" v-model="query.type" clearable style="width: 100px" placeholder="类型">-->
<!--                <el-option v-for="(v, k) in $root.image_type_enum" :label="v" :value="parseInt(k)"></el-option>-->
<!--            </el-select>-->
            <el-select :disabled="loading" v-model="query.video" clearable style="width: 100px" placeholder="激励视频">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-select :disabled="loading" v-model="query.is_animated" clearable style="width: 100px" placeholder="是否动图">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-select :disabled="loading" v-model="query.online" clearable style="width: 200px" placeholder="已选上线时间">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
            </el-select>
            <el-input :disabled="loading" v-model="query.id" style="width: 100px" placeholder="ID"></el-input>
<!--            <el-button type="success" :loading="loading" @click="fetchImages(1)">查询</el-button>-->
            <date-range-picker v-model="query" start-placeholder="上线开始时间" end-placeholder="上线结束时间"
                               :disabled="loading"></date-range-picker>
        </div>
        <el-table :data="dataPage" v-loading="loading" style="margin-top: 10px">
            <el-table-column label="ID" prop="id" width="250">
                <template #default="scope">
                    <div>{{ scope.row.id }}</div>
                    <div style="text-align: center">
                        <a :href="`${$root.cdn_url}/${scope.row.resource}`" target="_blank">查看原图</a>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="缩略图" prop="thumbnail" width="100">
                <template #default="scope">
                    <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 90px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="完成动图" prop="animation" width="100">
              <template #default="scope">
                <video v-if="scope.row.animation" :src="`${$root.cdn_url}/${scope.row.animation}`" controls muted
                       style="width: 90px"></video>
              </template>
            </el-table-column>
            <el-table-column label="模块" prop="module" width="100">
                <template #default="scope">
                    {{ $root.image_module_enum[scope.row.module] }}
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="200">
                <template #default="scope">
                    <template v-for="key in scope.row.categories">
                        <template v-for="c in category_list">
                            <el-tag v-if="c.key === key">{{ c.i18n_name.EN }}</el-tag>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="视频" prop="video" width="100">
                <template #default="scope">
                    {{ scope.row.video ? '是' : '' }}
                </template>
            </el-table-column>
            <el-table-column label="上线时间" prop="online_date" width="150">
<!--              <template #default="scope">-->
<!--                <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"-->
<!--                                @change="update(scope.row)" :clearable="false"></el-date-picker>-->
<!--              </template>-->
              <template #default="scope">
                {{ this.get_online_date(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="id" width="150"></el-table-column>
            <el-table-column label="操作" width="200">
                <template #default="scope">
                    <el-button type="primary" size="small" :disabled="this.get_online_date(scope.row) === this.selected_day || loading"
                               @click="online(scope.row)">{{ this.get_online_date(scope.row) === this.selected_day ? '已上线' : '上线' }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                       :page-size="limit"></el-pagination>
        <template #footer>
            <el-button type="primary" @click="reset" :disabled="loading">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import {VueDraggableNext} from 'vue-draggable-next'
import {isEmpty, timestampToDate, update} from "../libs/utils";
import DateRangePicker from "../base/DateRangePicker.vue";
import {getProduct} from "../libs/app.ts";

export default {
    name: "Update",
    components: {DateRangePicker, VueDraggableNext},
    data() {
        return {
            loading: false, data: [], dialog_opened: false, category_list: [], country: "GLOBAL",
            today: timestampToDate(Date.now()), date: new Date(), platform: 'android',
            data_map: {}, day_image_list: [],  image_list: [],  total: 0, page: 1, skip: 0, limit: 50,
            selected_day: null, sort_list_map: {},
            // page_data: [],
            query: this.createQuery(),
            form: {
                date: '',
            }
        }
    },
    methods: {
      getProduct,
        init() {
            this.loading = true;
            // const now = Date.now();
            const month = this.date.getMonth() + 1 + '';
            axios.get(`/cms/v1/image`, {
                params: {
                    module: 1,
                    start: `${this.date.getFullYear()}-${month.length > 1 ? month : '0' + month}-01`,
                    // end: `${this.date.getFullYear()}-${month.length > 1 ? month : '0' + month}-31`,
                    include_none_date: true,
                    product: getProduct().key,
                }
            }).then(res => {
                this.image_list = res.data.data.imageList;
              // this.total = res.data.data.total;
                this.formatData()
                this.total = this.imageList.length
                this.loading = false;
            })
        },
        formatData() {
          this.data_map = {}
          this.image_list.forEach(image => {
            if (image.online_date) {
              if (this.data_map[image.online_date]) {
                this.data_map[image.online_date].push(image);
              } else {
                this.data_map[image.online_date] = [image];
              }
            }
          });
          for (const date in this.data_map) {
            const images = this.data_map[date];
            if(images) {
              this.data_map[date] = images.sort(
                  (a, b) => (
                      this.getSort(a) - this.getSort(b)
                  )
              );
            }
          }
        },
        createQuery() {
          return {
            category:  null,
            module: 1,
            online: null,
            video: null,
            is_animated: null,
            id: null,
            start: null,
            end: null,
          }
        },
        fetchImages(page) {
            this.skip = (page - 1) * this.limit;
            this.page = page
            this.total = this.imageList.length
        },
        reset() {
            this.loading = this.dialog_opened = false;
        },
        openDialog(day) {
          this.dialog_opened = true;
          this.sort_list_map = {}
          this.query = this.createQuery()
          this.selected_day = day;
          this.page = 1
          this.skip = 0
          this.day_image_list = []
          this.total = 0
          if (this.data_map[day]) {
            this.day_image_list = this.data_map[day]
          }
          this.total = this.imageList.length
        },
        get_online_date(image) {
            // return image.online_dates.hasOwnProperty(getProduct().key) ? image.online_dates[getProduct().key]: image.online_date;
          return image.online_date
        },
        online(image) {
            this.loading = true;
            let online_date = this.get_online_date(image)
            if (online_date && this.data_map[online_date]) {
              this.data_map[online_date] = this.data_map[online_date].filter(i => i.id !== image.id);
            }
            image.online_date = this.selected_day
            // image.online_dates[getProduct().key] = this.selected_day
            online_date = this.get_online_date(image)
            if (this.data_map[online_date]) {
              this.data_map[online_date].push(image)
            } else {
              this.data_map[online_date] = [image]
            }
            if (this.data_map[online_date]) {
              this.day_image_list = this.data_map[online_date]
            }
            this.sort_list_map = {}
            axios.put(`/cms/v1/online/image/${image.id}`, {product: getProduct().key, online_date: online_date}).then(res => {
                this.loading = false;
            })
        },
        offline(image) {
            this.loading = true;
            let online_date = this.get_online_date(image)
            if (this.data_map[online_date]) {
              this.data_map[online_date] = this.data_map[online_date].filter(i => i.id !== image.id);
              this.day_image_list = this.data_map[online_date]
            }
            this.sort_list_map = {}
            image.online_date = null
            // image.online_dates[getProduct().key] = null
            axios.put(`/cms/v1/online/image/${image.id}`, {product: getProduct().key, online_date: null}).then(res => {
                // this.day_image_list.splice(this.day_image_list.indexOf(image), 1);
                this.loading = false;
            })
        },
        batchOnline() {
            axios.post(`/cms/v1/batch-online/image`, {date: this.selected_day}).then(_ => {
              this.reset()
              this.init()
            })
        },
        updateVideo(row) {
            this.loading = true;
            row.video = !row.video;
            axios.put(`/cms/v1/image/${row.id}`, row).then(res => {
                this.loading = false;
            });
        },
        sort() {
            this.loading = true;
            const sort = [];
            this.dayImageList.forEach((d, i) => {
              sort.push(d.id)
              if(this.sortType() === "android-GLOBAL") {
                d.sort = i
              } else {
                if (d.sorts == null) {
                  d.sorts = {}
                }
                d.sorts[this.sortType()] = i
              }
            });
            axios.post(`/cms/v1/sort/image`, {sort, sort_type: this.sortType()}).then(res => {
                this.loading = false;
            })
        },
        sortType() {
          if (getProduct().key === 'classic') {
            return this.platform + "-" + this.country;
          } else {
            return getProduct().key + "-" + this.platform + "-" + this.country;
          }
        },
        fallbackSortType() {
          if (getProduct().key === 'classic') {
            return "android-GLOBAL";
          } else {
            return getProduct().key + "-" + "android-GLOBAL";
          }
        },
        selectDate(value) {
            this.$refs.calendar.selectDate(value);
        },
        update(row) {
          this.formatData()
          this.sort_list_map = {}
          axios.put(`/cms/v1/image/${row.id}`, row).then(_ => {
          })
        },
        getSort(image) {
          return (image?.sorts?.[this.sortType()] ?? image?.sorts?.[this.fallbackSortType()] ?? image.sort ?? 0)
        }
    },
    computed: {
      dataPage() {
          return this.imageList.slice(this.skip, this.skip + this.limit)
      },
      imageList() {
        return this.image_list.filter(
            item => (item.platform === null || item.platform === undefined || item.platform === "" || item.platform === this.platform) &&
                (!item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                (!item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country)) &&
                (!this.get_online_date(item) || this.get_online_date(item) > this.selected_day) &&
                (!this.query.module && this.query.module !== 0 || item.module === this.query.module) &&
                (!this.query.category || (item.categories && item.categories.includes(this.query.category))) &&
                (!this.query.id || item.id === this.query.id) &&
                (!this.query.start || (this.get_online_date(item) && this.get_online_date(item) >= this.query.start)) &&
                (!this.query.end || (this.get_online_date(item) && this.get_online_date(item) <= this.query.end)) &&
                (!this.query.online || this.query.online && this.get_online_date(item) && this.get_online_date(item) < this.today || !this.query.online && (!this.get_online_date(item) || this.get_online_date(item) > this.today)) &&
                (this.query.video === null || this.query.video === undefined || this.query.video === item.video) &&
                (this.query.is_animated === null || this.query.is_animated === undefined || this.query.is_animated === !!item.animation))
            .sort((a, b) => {
              // const a_current = a.online_date === this.selected_day;
              // const b_current = b.online_date === this.selected_day;
              // if (a_current && !b_current) return -1;
              // if (!a_current && b_current) return 1;
              if (isEmpty(this.get_online_date(a)) && isEmpty(this.get_online_date(b))) {
                return a.id < b.id
                // return (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0);
              }
              if (isEmpty(this.get_online_date(a))) return -1;
              if (isEmpty(this.get_online_date(b))) return 1;
              if (this.get_online_date(a) !== this.get_online_date(b)) {
                return this.get_online_date(a) < this.get_online_date(b) ? -1 : 1;
              }
              return this.getSort(a) - this.getSort(b)
            });
      },
      dayImageList: {
        get() {
          if (!this.sort_list_map[this.sortType()]){
            const list = this.day_image_list.filter(
                item => ( (item.platform === null || item.platform === undefined || item.platform === this.platform) &&
                (!item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                    (!item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country))));
            this.sort_list_map[this.sortType()] = list.sort(
                (a, b) => (
                    this.getSort(a) - this.getSort(b)
                )
            );
          }
          return this.sort_list_map[this.sortType()]
        },
        set(value) {
          this.sort_list_map[this.sortType()] = value
        }
      }
    },
    mounted() {
      axios.all([
        axios.get('/cms/v1/category').then(res => {
          this.category_list = res.data.data.categoryList;
        }),
      ]).then(_ => {
        this.loading = false;
        this.init();
      })
    },
    watch: {
        date(latest, previous) {
            if (latest.getMonth() < previous.getMonth() || latest.getFullYear() < previous.getFullYear()) {
              this.init();
            }
        },
        country(latest, previous) {
          this.sort_list_map = {}
          this.day_image_list.sort((a, b)=>(this.getSort(a) - this.getSort(b)));
        },
        platform(latest, previous) {
          this.sort_list_map = {}
          this.day_image_list.sort((a, b)=>( this.getSort(a) - this.getSort(b)));
        },
        query: {
          handler(newQuery, oldQuery) {
            this.fetchImages(1)
          },
          deep: true
        }
    }
}
</script>

<style scoped>
.el-calendar ::v-deep(.el-calendar-day) {
    height: fit-content;
    width: 160px;
    min-height: var(--el-calendar-cell-width);
}

.el-select {
  width: 200px;
}

</style>
